import { useEffect, useRef, useState } from 'react';

export const useHighlightKeys = (items = [], getKey, timeout = 1200) => {
    const [highlightedKeys, setHighlightedKeys] = useState(new Set());

    const previousKeysRef = useRef([]);
    const timeoutMapRef = useRef(new Map());

    useEffect(() => {
        const currentKeys = items.map(getKey);
        const previousKeys = previousKeysRef.current;

        const newKeys = currentKeys.filter(k => !previousKeys.includes(k));

        previousKeysRef.current = currentKeys;

        if (newKeys.length === 0) return;

        setHighlightedKeys(prev => {
            const updated = new Set(prev);
            newKeys.forEach(k => updated.add(k));
            return updated;
        });

        newKeys.forEach(key => {
            if (timeoutMapRef.current.has(key)) return;

            const timeoutId = setTimeout(() => {
                setHighlightedKeys(prev => {
                    const updated = new Set(prev);
                    updated.delete(key);
                    return updated;
                });
                timeoutMapRef.current.delete(key);
            }, timeout);

            timeoutMapRef.current.set(key, timeoutId);
        });

        const currentKeySet = new Set(currentKeys);
        timeoutMapRef.current.forEach((timeoutId, key) => {
            if (!currentKeySet.has(key)) {
                clearTimeout(timeoutId);
                timeoutMapRef.current.delete(key);
            }
        });
    }, [items, getKey, timeout]);

    return highlightedKeys;
};
